import angular from 'angular'
const deductionListPage = require('./views/deductionConfigList.html')
const deductionConfigCtrl = require('./deductionConfigCtrl')
export default angular
    .module('input.basedata.deductionConfig', [])
    .config([
        '$stateProvider',
        function config($stateProvider) {
            $stateProvider
                .state('input.basedata.deductionConfig', {
                    url: '/deductionConfig',
                    abstract: true,
                    template: '<div ui-view></div>',
                    default: 'input.basedata.deductionConfig.list',
                    title: '抵扣配置',
                })
                .state('input.basedata.deductionConfig.list', {
                    url: '/list',
                    template: deductionListPage,
                    controller: 'deductionConfigCtrl',
                })
        },
    ])
    .controller('deductionConfigCtrl', deductionConfigCtrl.default).name



// WEBPACK FOOTER //
// ./src/app/input/basedata/deductionConfig/index.js